var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconXp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1291_96099",
    x1: 6.10167,
    y1: 6.09614,
    x2: 18.0576,
    y2: 18.0521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.25
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.999
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2996 0.89821L0.903743 11.2941C0.472945 11.7249 0.472945 12.4233 0.903743 12.8541L11.2996 23.25C11.7304 23.6808 12.4289 23.6808 12.8597 23.25L23.2555 12.8541C23.6863 12.4233 23.6863 11.7249 23.2555 11.2941L12.8597 0.89821C12.4289 0.467412 11.7304 0.467412 11.2996 0.89821Z",
    fill: "#8743FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2996 0.89821L0.903743 11.2941C0.472945 11.7249 0.472945 12.4233 0.903743 12.8541L11.2996 23.25C11.7304 23.6808 12.4289 23.6808 12.8597 23.25L23.2555 12.8541C23.6863 12.4233 23.6863 11.7249 23.2555 11.2941L12.8597 0.89821C12.4289 0.467412 11.7304 0.467412 11.2996 0.89821Z",
    fill: "url(#paint0_linear_1291_96099)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.2993 4.31423L4.31945 11.2941C3.88866 11.7249 3.88866 12.4233 4.31945 12.8541L11.2993 19.834C11.7301 20.2648 12.4286 20.2648 12.8593 19.834L19.8392 12.8541C20.27 12.4233 20.27 11.7249 19.8392 11.2941L12.8593 4.31423C12.4286 3.88343 11.7301 3.88343 11.2993 4.31423Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.791 2.66705L17.4567 4.29337L16.3375 4.6189C15.8819 4.72494 15.8697 5.36901 16.3213 5.4925L17.4991 5.83941L17.7879 7.42472C17.8983 7.89119 18.5647 7.88552 18.6663 7.41686L19.0132 5.80799L20.1421 5.48901C20.5898 5.38341 20.6103 4.75374 20.17 4.61977L18.9923 4.20959L18.6768 2.66356C18.5834 2.17308 17.8804 2.17614 17.791 2.66748V2.66705Z",
    fill: "#FFA500",
    stroke: "#FFBC52",
    strokeWidth: 0.0872727,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17091 16.3309L4.83665 17.9572L3.71738 18.2827C3.26182 18.3888 3.2496 19.0329 3.70124 19.1563L4.87898 19.5033L5.16785 21.0886C5.27825 21.555 5.94458 21.5494 6.04625 21.0807L6.39316 19.4718L7.52204 19.1529C7.96975 19.0473 7.99025 18.4176 7.54996 18.2836L6.37222 17.8734L6.05673 16.3274C5.96335 15.8369 5.26036 15.84 5.17091 16.3313V16.3309Z",
    fill: "#FFA500",
    stroke: "#FFBC52",
    strokeWidth: 0.0872727,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1824 21.8797C18.8015 21.8797 19.3034 21.3778 19.3034 20.7587C19.3034 20.1396 18.8015 19.6377 18.1824 19.6377C17.5633 19.6377 17.0614 20.1396 17.0614 20.7587C17.0614 21.3778 17.5633 21.8797 18.1824 21.8797Z",
    fill: "#FFA500",
    stroke: "#FFBC52",
    strokeWidth: 0.0872727,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3913 18.7148C20.8101 18.7148 21.1497 18.3752 21.1497 17.9564C21.1497 17.5375 20.8101 17.198 20.3913 17.198C19.9724 17.198 19.6329 17.5375 19.6329 17.9564C19.6329 18.3752 19.9724 18.7148 20.3913 18.7148Z",
    fill: "#FFA500",
    stroke: "#FFBC52",
    strokeWidth: 0.0872727,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7463 11.3565C16.7463 11.6619 16.6748 11.941 16.5316 12.1938C16.3933 12.4419 16.181 12.6423 15.8947 12.7949C15.6132 12.9428 15.2674 13.0168 14.8571 13.0168H14.1629V14.72H12.7602V9.67477H14.8571C15.2626 9.67477 15.6061 9.74634 15.8876 9.88947C16.1738 10.0326 16.3885 10.2306 16.5316 10.4834C16.6748 10.7363 16.7463 11.0273 16.7463 11.3565ZM14.7211 11.9004C15.1171 11.9004 15.3151 11.7191 15.3151 11.3565C15.3151 10.9892 15.1171 10.8055 14.7211 10.8055H14.1629V11.9004H14.7211Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6258 14.72L9.64538 13.2959L8.80808 14.72H7.21222L8.85102 12.1366L7.15496 9.67477H8.80808L9.75988 11.0631L10.5757 9.67477H12.1716L10.5542 12.2153L12.2789 14.72H10.6258Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.18196 3.93296C6.72975 3.93296 7.17382 3.48889 7.17382 2.9411C7.17382 2.39332 6.72975 1.94925 6.18196 1.94925C5.63418 1.94925 5.19011 2.39332 5.19011 2.9411C5.19011 3.48889 5.63418 3.93296 6.18196 3.93296Z",
    fill: "#FFA500",
    stroke: "#FFBC52",
    strokeWidth: 0.0872727,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17207 6.04582C4.54248 6.04582 4.84276 5.74554 4.84276 5.37513C4.84276 5.00472 4.54248 4.70444 4.17207 4.70444C3.80166 4.70444 3.50138 5.00472 3.50138 5.37513C3.50138 5.74554 3.80166 6.04582 4.17207 6.04582Z",
    fill: "#FFA500",
    stroke: "#FFBC52",
    strokeWidth: 0.0872727,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXp);
export default __webpack_public_path__ + "static/media/icon-xp.25d01652d87d6c48717989874cfb9fc5.svg";
export { ForwardRef as ReactComponent };